document.addEventListener("DOMContentLoaded", function () {
  Object.assign(window.GzTheme, {
    namespace: "GZ-WARRANTY",

    warrantyTypes: {
      oem: "OEM Warranty",
      pp: "Protection Plan",
    },

    initProtectionPlan: function () {
      const addProtectionPlan = document.querySelectorAll("[data-add-protection-plan-gz]");
      const removeProtectionPlan = document.querySelectorAll("[data-remove-protection-plan-gz]");
      if (!addProtectionPlan || !removeProtectionPlan) {
        throw new Error("Protection Add/Remove button not found!");
      };

      // Add Protection Plan
      addProtectionPlan.forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          window.GzTheme.protectionPlanLoading(button, true);

          try {
            const productKey = button.dataset.protectionPlanProductKey;
            const productId = button.dataset.protectionPlanProductId;
            const protectionPlanId = parseInt(button.dataset.protectionPlanId);
            if(!protectionPlanId || !productKey || !productId) return;

            await window.GzTheme.addProtectionPlan(productKey, productId, protectionPlanId);
          } catch (error) {
            throw new Error("Failed: Adding protection plan from cart page.", error);
          } finally {
            await window.GzTheme.delay(500);
            window.GzTheme.protectionPlanLoading(button, false);
            location.reload();
          }
        });
      });

      // Remove Protection Plan
      removeProtectionPlan.forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          window.GzTheme.protectionPlanLoading(button, true);

          try {
            const productKey = button.dataset.protectionPlanProductKey;
            const productId = button.dataset.protectionPlanProductId;
            const protectionPlanKey = button.dataset.protectionPlanKey;
            if(!productKey || !productId || !protectionPlanKey) return;

            await window.GzTheme.removeProtectionPlan(productKey, productId, protectionPlanKey);
          } catch (error) {
            throw new Error("Failed: Removing protection plan from cart page.", error);
          } finally {
            await window.GzTheme.delay(500);
            window.GzTheme.protectionPlanLoading(button, false);
            location.reload();
          }
        });
      });
    },


    //
    // Add Protection Plan
    //
    addProtectionPlan: async function(productKey, productId, protectionPlanId) {
      const NS = window.GzTheme?.namespace;
      const warrantyType = window.GzTheme?.warrantyTypes?.pp || "Protection Plan";
    
      try {
        // 1. Sync latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items;
        if (!cartItems) throw new Error(`[${NS}] - Failed to fetch cart items addProtectionPlan()`);
    
        // 2. Find the product from cart
        const product = cartItems.find(item => item.key === productKey);
        if (!product) throw new Error(`[${NS}] - Product not found in cart addProtectionPlan()`);

        // 3. Get product and associated warranty from Cart 
        const { productInCart, warrantyInCart } = 
          await window.GzTheme.productHasWarrantyInCart(cartItems, productKey, productId, warrantyType);

        // 4. Find associated OEM warranty (if any)
        const associatedOemWarranty = await window.GzTheme.associatedOemWarrantyInCart(cartItems, product);

        let quantity = product.quantity
        if(productInCart) {
          quantity = quantity + productInCart.quantity
        }

        // 5. Remove OEM, Orphan Protection Plan and Orphan Product if available
        const removePayload = {};
        if (productInCart?.key) removePayload[productInCart.key] = 0;
        if (warrantyInCart?.key) removePayload[warrantyInCart.key] = 0;
        if (associatedOemWarranty?.key) removePayload[associatedOemWarranty.key] = 0;
        
        if (Object.keys(removePayload).length) {
          const removeRes = await window.GzTheme.updateCart(
            window.GzTheme.CART_UPDATE_ENDPOINT, removePayload
          );
          if (!removeRes) throw new Error(`[${NS}] - Failed to remove Protection Plan`);
        }

        // 6. Update product properties for new Warranty
        const updatePayload = {
          id: productKey,
          quantity: quantity,
          properties: {
            ...product.properties,
            "_warranty.type": warrantyType,
            "_warranty.variant_id": parseInt(protectionPlanId)
          }
        };
        const updateRes = await window.GzTheme.updateCart(window.GzTheme?.CART_CHANGE_ENDPOINT, updatePayload);
        if (!updateRes) throw new Error(`[${NS}] - Failed to update product properties`);

        // 7. Add Protection Plan after removing OEM Warranty
        const addPayload = {
          items: [
            {
              id: protectionPlanId,
              quantity: quantity,
              properties: {
                "_warranty": warrantyType,
                "_warranty.associated_variant_id": parseInt(productId)
              }
            }
          ]
        };
        const addRes = await window.GzTheme.addToCart(addPayload);
        if (!addRes) throw new Error(`[${NS}] - Failed to add OEM Warranty`);
      } catch (err) {
        console.error(`[${NS}] - addProtectionPlan error:`, err);
        throw new Error(`[${NS}] - ${err?.message || "Unexpected error"}`);
      }
    },


    //
    // Remove Protection Plan
    //
    removeProtectionPlan: async function(productKey, productId, protectionPlanKey) {
      const NS = window.GzTheme?.namespace;
      const warrantyType = window.GzTheme?.warrantyTypes?.oem || "OEM Warranty";
      const oemWarrantyId = window.GzTheme.GZ_OEM.id;
    
      try {
        // 1. Sync latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items;
        if (!cartItems) throw new Error(`[${NS}] - Failed to fetch cart items removeProtectionPlan()`);
    
        // 2. Find the product from cart
        const product = cartItems.find(item => item.key === productKey);
        if (!product) throw new Error(`[${NS}] - Product not found in cart removeProtectionPlan()`);

        // 3. Get product and associated warranty from Cart 
        const { productInCart, warrantyInCart } = 
          await window.GzTheme.productHasWarrantyInCart(cartItems, productKey, productId, warrantyType);

        let quantity = product.quantity
        if(productInCart) {
          quantity = quantity + productInCart.quantity
        }

        // 4. Remove Protection Plan, Orphan OEM and Orphan Product if available
        const removePayload = {};
        if (protectionPlanKey) removePayload[protectionPlanKey] = 0;
        if (productInCart?.key) removePayload[productInCart.key] = 0;
        if (warrantyInCart?.key) removePayload[warrantyInCart.key] = 0;
        
        if (Object.keys(removePayload).length) {
          const removeRes = await window.GzTheme.updateCart(
            window.GzTheme.CART_UPDATE_ENDPOINT, removePayload
          );
          if (!removeRes) throw new Error(`[${NS}] - Failed to remove Protection Plan`);
        }

        // 5. Update product properties for new Warranty
        const updatePayload = {
          id: productKey,
          quantity: quantity,
          properties: {
            ...product.properties,
            "_warranty.type": warrantyType,
            "_warranty.variant_id": parseInt(oemWarrantyId)
          }
        };
        const updateRes = await window.GzTheme.updateCart(window.GzTheme?.CART_CHANGE_ENDPOINT, updatePayload);
        if (!updateRes) throw new Error(`[${NS}] - Failed to update product properties`);

        // 6. Add OEM Warranty after removing Protection Plan
        const addPayload = {
          items: [
            {
              id: oemWarrantyId,
              quantity: quantity,
              properties: {
                "_warranty": warrantyType,
                "_warranty.associated_variant_id": parseInt(productId)
              }
            }
          ]
        };
        const addRes = await window.GzTheme.addToCart(addPayload);
        if (!addRes) throw new Error(`[${NS}] - Failed to add OEM Warranty`);
      } catch (err) {
        console.error(`[${NS}] - removeProtectionPlan error:`, err);
        throw new Error(`[${NS}] - ${err?.message || "Unexpected error"}`);
      }
    },
    

    //
    // Fetch cart data
    // Update the 'window.GzTheme.CART_DATA' state
    //
    fetchCart: async function () {
      const NS = window.GzTheme?.namespace;
      const endpoint = window.GzTheme.CART_JSON_ENDPOINT;
    
      try {
        const response = await fetch(endpoint);
        const data = await response.json();
    
        if (!response.ok) {
          const error = new Error(`[${NS}] - Failed to fetch cart — status ${response.status}`);
          error.responseData = data;
          error.endpoint = endpoint;
          throw error;
        }
    
        window.GzTheme.CART_DATA = data;
        return data;
      } catch (error) {
        console.error(`[${NS}] - fetchCart error:`, error);
        error.endpoint = error.endpoint || endpoint;
        throw new Error(`[${NS}] - ${error.message}`);
      }
    },


    //
    // Add to Cart
    //
    addToCart: async function (payload) {
      const NS = window.GzTheme?.namespace;
      const endpoint = window.GzTheme.CART_ADD_ENDPOINT;
    
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
    
        const data = await res.json();
    
        if (!res.ok) {
          throw new Error(`[${NS}] - Failed to add to cart — ${data.message || 'Unknown error'}`);
        }
    
        return data;
      } catch (error) {
        console.error(`[${NS}] - addToCart error:`, error);
        throw new Error(`[${NS}] - ${error.message}`);
      }
    },
    

    //
    // Update cart items
    //
    updateCart: async function (endpoint, payload) {
      const NS = window.GzTheme?.namespace;

      try {
        const body = endpoint.includes("update")
          ? { updates: payload }
          : { ...payload };
    
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
    
        const data = await response.json();
    
        if (!response.ok) {
          throw new Error(`[${NS}] - Failed to update cart — status ${response.status}`);
        }
    
        return data;
      } catch (error) {
        console.error(`[${NS}] - updateCart error:`, error);
        throw new Error(`[${NS}] - ${error.message}`);
      }
    },


    //
    // Product in Cart has Warranty (OEM or Protection Plan)
    //
    productHasWarrantyInCart: async function(cartItems, productKey, productId, warrantyType) {
      let product = null;
      let warranty = null;

      for (const item of cartItems) {
        const props = item?.properties;

        // Find main product with protection
        if (
          String(item.key) !== String(productKey) &&
          String(item.id) === String(productId) &&
          props["_warranty.type"] === warrantyType
        ) {
          product = item;
        }

        // Find associated OEM Warranty
        if (
          props["_warranty"] === warrantyType &&
          String(props["_warranty.associated_variant_id"]) === String(productId)
        ) {
          warranty = item;
        }
      }

      return {
        productInCart: product || null,
        warrantyInCart: warranty || null
      };
    },


    //
    // Returns the OEM warranty item associated with a given product.
    //
    associatedOemWarrantyInCart: async function(cartItems, product) {
      if (!product || !cartItems) return null;

      // Find the Associated OEM Warranty item
      const warrantyType = window.GzTheme?.warrantyTypes?.oem || "OEM Warranty";
      const associatedOemWarranty = cartItems.find(item => {
        const props = item.properties || {};
        return (
          props["_warranty"] ===  warrantyType &&
          String(props["_warranty.associated_variant_id"]) === String(product.id)
        );
      }) || null;

      return associatedOemWarranty || null;
    },


    //
    // Sync Protection Plan and OEM warranty quantity
    //
    cartSync: async function () {
      try {
        // 1. Fetch latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items;
        if (!Array.isArray(cartItems)) return false;
    
        const payload = {};
        const usedWarrantyKeys = new Set();
    
        const warrantyTypes = window.GzTheme?.warrantyTypes || {};
        const PROTECTION_PLAN = warrantyTypes.pp || "Protection Plan";
        const OEM_WARRANTY = warrantyTypes.oem || "OEM Warranty";
    
        // Helper function to find associated warranty for a main product
        const findAssociatedWarranty = (mainProduct, type) => {
          return cartItems.find(item =>
            item?.properties?.["_warranty"] === type &&
            String(item?.properties?.["_warranty.associated_variant_id"]) === String(mainProduct.id)
          );
        };
    
        for (const item of cartItems) {
          const props = item?.properties;
          if (!props || !props["_warranty.type"]) continue;
          const type = props["_warranty.type"];
    
          // 2. Handle Protection Plan sync
          if (type === PROTECTION_PLAN) {
            const associated = findAssociatedWarranty(item, PROTECTION_PLAN);
            if (associated) {
              usedWarrantyKeys.add(associated.key);
              usedWarrantyKeys.add(item.key);
    
              if (associated.quantity !== item.quantity) {
                payload[associated.key] = item.quantity; // sync warranty quantity to match product
              }
            }
          }
    
          // 3. Handle OEM Warranty sync
          else if (type === OEM_WARRANTY) {
            const associated = findAssociatedWarranty(item, OEM_WARRANTY);
            if (associated) {
              usedWarrantyKeys.add(associated.key);
              usedWarrantyKeys.add(item.key);
    
              if (associated.quantity !== item.quantity) {
                payload[associated.key] = item.quantity;
              }
            }
          }
        }
    
        // 4. Remove orphaned warranties (no main product match)
        for (const item of cartItems) {
          if (usedWarrantyKeys.has(item.key)) continue;
    
          const props = item?.properties;
          const isOrphanProtection =
            props?.["_warranty"] === PROTECTION_PLAN &&
            !!props?.["_warranty.associated_variant_id"];
    
          const isOrphanOEM =
            props?.["_warranty"] === OEM_WARRANTY &&
            !!props?.["_warranty.associated_variant_id"];
    
          if (isOrphanProtection || isOrphanOEM) {
            payload[item.key] = 0; // remove from cart
          }
        }
    
        // 5. Update cart only if there are changes
        if (Object.keys(payload).length > 0) {
          await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
        }
    
      } catch (error) {
        console.error(`[${NS}] - cartSync error:`, error);
        throw error;
      }
    },


    //
    // Toggle loading, skeleton leader protection plan
    //
    protectionPlanLoading: function(button, isLoading) {
      const parent = button.closest('.gz-protection-plan');
      if (!parent) return;
    
      if (isLoading) {
        parent.classList.add('loading');
      } else {
        parent.classList.remove('loading');
      }
    },


    //
    // Delay an Async function
    //
    delay: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  });

  // Update the Protection Plan and OEM when product quantity changes on cart page
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const NS = window.GzTheme?.namespace;

    try {
      await window.GzTheme.cartSync();
    } catch (error) {
      throw new Error(`[${NS}] - Failed to sync cart from cartUpdate() event: ${error}`);
    } finally {
      await window.GzTheme.delay(500);
      location.reload();
    }
  });

  window.GzTheme.initProtectionPlan();
});